export const reorderArabicText = text => {
  const numbers = text.match(/\d+/g) || []
  const arabicText = text.replace(/\d+/g, '').replace(/\s+/g, ' ').trim()

  if (numbers.length > 0 && arabicText) {
    return `${numbers.join(' ')} ${arabicText}`
  }

  return numbers.length > 0 ? numbers.join(' ') : arabicText
}
